
import ReactDOM from 'react-dom'
import { useEffect, createRef } from 'react'

import { MessageHTML } from '@/components/commons/MessageHTML'
import { sanitizeHtml } from '@/helpers/html'

export function MainSectionHTML (props) {
  const shadowHost = createRef()
  useEffect(() => {
    if (!shadowHost?.current) return

    const { current } = shadowHost

    if (!current.attachShadow) {
      shadowHost.innerHTML = sanitizeHtml(props.html)
      return
    }
    
    // preventing attach twice
    if (!current.shadowRoot) current.attachShadow({ mode: 'open' })

    ReactDOM.render(
      <MessageHTML html={sanitizeHtml(props.html)}/>,
      current.shadowRoot,
    )
  }, [props.html])

  return <div className="main-section-html" ref={shadowHost}/>
}
